import React from 'react';
import { FileText } from 'lucide-react';

const DocumentWizard = ({ data, setData }) => {
  const handleChange = (field, value) => setData({ ...data, [field]: value });
  const toggleOption = (opt) => setData({
    ...data,
    docOptions: { ...data.docOptions, [opt]: !data.docOptions?.[opt] }
  });

  const options = [
    { id: 'techSpecs',  label: 'Especif. Técnica',  desc: 'Tablas, campos y arquitectura técnica' },
    { id: 'userSteps',  label: 'Guía de Pasos',      desc: 'Instrucciones paso a paso para el usuario' },
    { id: 'tablesUsed', label: 'Diccionario Datos',   desc: 'Tablas Z y estándar utilizadas' },
    { id: 'errorGuide', label: 'Solución Errores',    desc: 'Mensajes del sistema y resolución' },
  ];

  return (
    <div className="animate-in fade-in slide-in-from-top-4 duration-500 text-left space-y-6">

      {/* NOTA */}
      <div className="bg-indigo-900/10 border-l-4 border-indigo-600 p-5 rounded-r-3xl flex gap-4 items-start">
        <div className="bg-indigo-600 p-2 rounded-xl text-white shrink-0">
          <FileText size={18} />
        </div>
        <div>
          <p className="text-[11px] text-indigo-400 font-black uppercase tracking-widest mb-1">
            Document Generation Guide
          </p>
          <p className="text-[11px] text-slate-400 leading-relaxed">
            Generá manuales técnicos y de usuario profesionales para objetos SAP.
            Incluye especificación técnica, guía de pasos, diccionario de datos 
            y solución de errores. Ideal para documentar desarrollos antes de la puesta en producción.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

        {/* COLUMNA 1 */}
        <div className="bg-[#0F172A] p-6 rounded-[28px] text-white border-b-4 border-indigo-500 space-y-4">
          <label className="text-[10px] font-black text-indigo-400 uppercase flex items-center gap-2 border-b border-slate-800 pb-2">
            <FileText size={14}/> Configuración del Documento
          </label>

          <div>
            <label className="text-[9px] font-bold text-slate-400 uppercase block mb-1">
              Título del Documento / Programa
            </label>
            <input
              type="text"
              className="w-full p-2.5 bg-slate-800 border border-slate-700 rounded-xl text-xs text-white placeholder:text-slate-600 outline-none focus:border-indigo-400"
              placeholder="Ej: Reporte de Ventas por Región ZSD_VENTAS"
              value={data.docTitle || ''}
              onChange={(e) => handleChange('docTitle', e.target.value)}
            />
          </div>

          <div>
            <label className="text-[9px] font-bold text-slate-400 uppercase block mb-1">
              Módulo SAP Relacionado
            </label>
            <select
              className="w-full p-2.5 bg-slate-800 border-none rounded-xl text-xs font-bold text-white outline-none focus:ring-2 focus:ring-indigo-500"
              value={data.docModule || 'FI-CO'}
              onChange={(e) => handleChange('docModule', e.target.value)}
            >
              {['FI-CO', 'SD (Ventas)', 'MM (Compras)', 'PP (Producción)', 'WM/EWM', 'HCM', 'BASIS'].map(m => (
                <option key={m} value={m}>{m}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="text-[9px] font-bold text-slate-400 uppercase block mb-1">
              Tipo de Documento
            </label>
            <select
              className="w-full p-2.5 bg-slate-800 border-none rounded-xl text-xs font-bold text-white outline-none focus:ring-2 focus:ring-indigo-500"
              value={data.docType || 'Full (Tech + User)'}
              onChange={(e) => handleChange('docType', e.target.value)}
            >
              <option value="Full (Tech + User)">Full (Técnico + Usuario)</option>
              <option value="Technical Only">Solo Técnico</option>
              <option value="User Manual Only">Solo Manual de Usuario</option>
              <option value="Release Notes">Release Notes</option>
              <option value="Functional Spec">Especificación Funcional</option>
            </select>
          </div>
        </div>

        {/* COLUMNA 2 */}
        <div className="bg-[#0F172A] p-6 rounded-[28px] text-white border-b-4 border-indigo-500 space-y-4">
          <label className="text-[10px] font-black text-indigo-400 uppercase flex items-center gap-2 border-b border-slate-800 pb-2">
            <FileText size={14}/> Secciones del Documento
          </label>

          <div className="space-y-3">
            {options.map((opt) => (
              <button
                key={opt.id}
                onClick={() => toggleOption(opt.id)}
                className={`w-full flex items-center gap-3 p-3 rounded-xl border transition-all text-left ${
                  data.docOptions?.[opt.id]
                    ? 'bg-indigo-600/20 border-indigo-500/50'
                    : 'bg-slate-800 border-slate-700 hover:border-slate-600'
                }`}
              >
                <div className={`w-2 h-2 rounded-full shrink-0 ${data.docOptions?.[opt.id] ? 'bg-indigo-400 animate-pulse' : 'bg-slate-600'}`} />
                <div className="flex-1">
                  <p className={`text-[10px] font-black uppercase ${data.docOptions?.[opt.id] ? 'text-indigo-400' : 'text-slate-400'}`}>
                    {opt.label}
                  </p>
                  <p className="text-[9px] text-slate-500">{opt.desc}</p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentWizard;